






























import Vue from 'vue';
import {PlayerConfig} from '@/types/player-config';

export default Vue.extend({
  name: 'PlayerConfigEdit',
  props: {
    dialog: {
      type: Boolean,
      required: true,
      default: false
    },
    playerConfig: Object
  },
  data() {
    return {
      json: ''
    };
  },
  methods: {
    save() {
      try {
        const newConfig = Object.assign({}, this.playerConfig);
        (newConfig as any).config = JSON.parse(this.json);

        this.$emit('save', newConfig);
      } catch (e) {
        this.$store.commit('setMessage', {show: true, text: 'В JSON содержатся ошибки'});
      }
    }
  }
});
